import { Box, Flex, Grid, GridColumn, omitText, Typography } from '@kohler-dsm-library/kohler-core';
import clsx from 'clsx';
import React from 'react';
import { UtilityLinks } from '../UtilityLinks';
import classes from './index.module.scss';

export const UtilityBar = React.forwardRef((props, ref) => {
  const {
    brands,
    mod,
    loginMenu,
    storeMenu,
    languageMenu,
    menuType,
    setMenuType,
    favoritesCTA,
    cartBadgeCTA,
    userCTA,
    isLoggedIn,
    languagePicker,
    locationPickerCTA,
    userName,
    utilityLinksMobile,
    userCTAMobile,
    setIsOpenMobileMenu,
    ...rest
  } = props;

  const utilityLinks = {
    favoritesCTA,
    cartBadgeCTA,
    userCTA,
    isLoggedIn,
    languagePicker,
    locationPickerCTA,
    userName,
    utilityLinksMobile,
    userCTAMobile,
  };

  return (
    <Box className={classes.utilityBar} mod={mod} ref={ref} {...rest}>
      <Grid>
        <GridColumn className={classes.utilityBarContent}>
          {brands && (
            <Flex component="ul" className={classes.utilityBrands}>
              {brands.map((brand) => {
                const { isActive, ...brandProps } = brand;
                return (
                  <Box component="li" key={brand.text}>
                    <Typography
                      size="navigation-brand-switcher"
                      component="a"
                      target="_blank"
                      {...omitText(brandProps)}
                      className={clsx(classes.utilityBrand, isActive && classes.utilityBrandActive)}
                    >
                      {brand.text}
                    </Typography>
                  </Box>
                );
              })}
            </Flex>
          )}
          <UtilityLinks
            {...utilityLinks}
            menuType={menuType}
            className={classes.utilityLinksWrapper}
            loginMenu={loginMenu}
            storeMenu={storeMenu}
            languageMenu={languageMenu}
            setIsOpenMobileMenu={setIsOpenMobileMenu}
            setMenuType={setMenuType}
          />
        </GridColumn>
      </Grid>
    </Box>
  );
});
